import React from 'react';

interface EditButtonProps {
  onClick: () => void;
}

export const EditButton: React.FC<EditButtonProps> = ({ onClick }) => (
  <button
    onClick={onClick}
    className="border border-black rounded-full bg-white text-black px-3 ml-4"
    style={{ height: '23px' }}
  >
    編集
  </button>
);
